module.exports = __webpack_public_path__ + "static/media/footer.7ffc4fa9.svg";